<template>
	<div class="pcon">
		<!-- Карусель -->
		<div class="banner">
			<el-carousel height="4.13rem" @change="bannerC" ref="carousel" indicator-position="none" :autoplay="true">
				<el-carousel-item v-for="item in adListArr">
					<el-image @click="gowlink(item.link)" class="icon" fit="cover" :src="item.picture"></el-image>
				</el-carousel-item>
			</el-carousel>
			<div class="dian f-ct">
				<div @click="bannerDian(index)" :class="bannerIdx==index?'a':''" v-for="(item,index) in adListArr"></div>
			</div>
		</div>
		<!--  -->
		<div class="pageCon flex">
			<div class="pageConL">
				<leftBox/>
			</div>
			<div class="pageConR">
				<!-- Краткая сводка -->
				<div class="userNub f-bct">
					<div class="itm f-bct" @click="link('/smallBag',{value:'1'})">
						<div class="txt">
							<div class="t1">{{uinfoAll.storageCount}}</div>
							<div class="t2">Все товары</div>
						</div>
						<el-image :src="require('@/static/icon13.png')"></el-image>
					</div>
					<div class="itm f-bct" @click="link('/bigBag',{value:'2'})">
						<div class="txt">
							<div class="t1">{{uinfoAll.applyPackagingCount}}</div>
							<div class="t2">Консолидации</div>
						</div>
						<el-image :src="require('@/static/icon14.png')"></el-image>
					</div>
					<div class="itm f-bct" @click="link('/bigBag',{value:'4'})">
						<div class="txt">
							<div class="t1">{{uinfoAll.sentCount}}</div>
							<div class="t2">Отправленные грузы</div>
						</div>
						<el-image :src="require('@/static/icon15.png')"></el-image>
					</div>
				</div>
				<!-- Управление малыми посылками/маркировкой -->
				<div class="listBox f-bct">
					<div class="smallBox">
						<div class="tit f-bct">
							<div class="tl">
								<div class="bor"></div>
								<p>Мои товары</p>
							</div>
							<div class="tr" style="cursor: pointer;" @click="link('/smallBag')">
								<p>Подробнее</p>
								<el-image :src="require('@/static/icon16.png')"></el-image>
							</div>
						</div>
						<!-- Список малых посылок -->
						<div class="smallList" v-if="packageMiniArr.length">
							<div class="itm" v-for="(item,index) in packageMiniArr">
								<div class="sn f-bct">
									<div class="t1 f-ct">
										Номер：<span>{{item.expressNumber}}</span>
										<template>
											<p class="borMT"></p>
											<div class="manMT">Маркировка：{{item.memberCode||'?'}}</div>
										</template>
										<template>
											<p class="borMT"></p>
											<div class="manMT">груз：{{item.name||'？'}}</div>
										</template>
									</div>
									<div class="t2" v-if="item.status==0">Не загружено</div>
									<div class="t2" v-if="item.status==1">Загружено</div>
									<div class="t2" v-if="item.status==2">Ожидает упаковки</div>
									<div class="t2" v-if="item.status==3">Упаковано</div>
									<div class="t2" v-if="item.status==4">Отправлено</div>
									<div class="t2" v-if="item.status==5">Доставлено</div>
								</div>
								<div class="detail f-ct">
									<div class="msg f-ct">
										<el-image class="img" @click.stop="showImgViewer([item.imageUrl])" v-if="item.imageUrl" :src="item.imageUrl"></el-image>
										<el-image class="img" v-else :src="require('@/static/img4.png')"></el-image>
										<div class="r f-ct">
											<div class="cBox f-ct">
												<div class="nubitm">
													<el-image :src="require('@/static/icon17.png')"></el-image>
													<p>Длина：{{item.length||'?'}}см</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon18.png')"></el-image>
													<p>Ширина：{{item.width||'?'}}см</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon19.png')"></el-image>
													<p>Высота：{{item.height||'?'}}см</p>
												</div>
											</div>
											<div class="cBox f-ct">
												<div class="nubitm">
													<el-image :src="require('@/static/icon20.png')"></el-image>
													<p>Объём：{{item.volume||'?'}}см³</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon21.png')"></el-image>
													<p>Вес：{{item.weight||'?'}}кг</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon22.png')"></el-image>
													<p>Мелких：{{item.pieceNum}}шт</p>
												</div>
											</div>
										</div>
									</div>
									<div class="bor"></div>
									<div class="caozuo">
										<!-- <p class="t1" v-if="item.logisticsJson">Отследить</p> -->
										<p class="t1" style="margin-bottom: 0.06rem;" v-if="item.lookDetailStatus==0" @click="applyLookDetailF(item.id)">Запрос на просмотр пакет</p>
										<p class="t1" style="margin-bottom: 0.06rem;" v-if="item.lookDetailStatus==1">Подать заявку на просмотр пакета</p>
										<p class="t1" style="margin-bottom: 0.06rem;" v-if="item.lookDetailStatus==2" @click.stop="showImgViewer(item.lookDetailGallery)">Посмотреть пакет</p>
										
										<p class="t1" @click="link('/smallBagMsg',{id:item.id})">Подробности</p>
										<p class="t2" @click="hbDel1=true,delBigId=item.id" v-if="item.status==0">Удалить</p>
									</div>
								</div>
							</div>
						</div>
						<!-- Нет данных -->
						<div class="zw" v-if="!packageMiniArr.length">
							<el-image :src="require('@/static/zw1.png')"></el-image>
							<p class="t1">Нет данных о малых посылках</p>
						</div>
					</div>
					<div class="mtBox">
						<div class="tit f-bct">
							<div class="tl">
								<div class="bor"></div>
								<p style="font-size: 0.14rem;">Управление маркировкой</p>
							</div>
							<div class="tr" style="cursor: pointer;" @click="link('/maitouList')">
								<p style="font-size: 0.14rem;">Подробнее</p>
								<el-image :src="require('@/static/icon16.png')"></el-image>
							</div>
						</div>
						<div class="maitouList" v-if="memberCodeArr.length">
							<div class="mtItm f-bct" v-for="(item,index) in memberCodeArr">
								<div class="l f-ct">
									<div class="nub">{{index+1}}</div>
									<!-- <el-image v-if="item.isDefault" :src="require('@/static/icon23.png')"></el-image> -->
									<p>{{item.memberCode}}</p>
								</div>
								<div class="r">
									<div class="btnItm" @click="mtChange(item)">
										<el-image :src="require('@/static/icon24.png')"></el-image>
										<p class="t1">Редактировать</p>
									</div>
									<div class="bor"></div>
									<div class="btnItm" @click="mtDel(item)">
										<el-image :src="require('@/static/icon25.png')"></el-image>
										<p class="t2">Удалить</p>
									</div>
								</div>
							</div>
						</div>
						<!-- Нет данных -->
						<div class="zw" v-if="!memberCodeArr.length">
							<el-image :src="require('@/static/zw2.png')"></el-image>
							<p class="t1">Нет данных</p>
						</div>
					</div>
				</div>
				<!-- Крупные посылки/Прайс-лист -->
				<div class="listBox f-bct">
					<div class="smallBox">
						<div class="tit f-bct">
							<div class="tl">
								<div class="bor"></div>
								<p>Отправленные товары</p>
							</div>
							<div class="tr" @click="link('/bigBag')">
								<p>Подробнее</p>
								<el-image :src="require('@/static/icon16.png')"></el-image>
							</div>
						</div>
						<!-- Список крупных посылок -->
						<div class="smallList" v-if="packageBigArr.length">
							<div class="itm" v-for="(item,index) in packageBigArr">
								<div class="sn f-bct">
									<div class="t3 f-ct">
										<div class="snTxt">
											Номер：<span>{{item.bigExpressNumber}}</span>
										</div>
										<template v-if="item.status!=2">
											<p class="bor"></p>
											<div class="man">Упаковщик：{{item.packerName}}</div>
										</template>

									</div>
									<div class="t2" v-if="item.status == 2">Ожидает упаковки</div>
									<div class="t2" v-if="item.status == 3">Упаковано</div>
									<div class="t2" v-if="item.status == 4">Отправлено</div>
									<div class="t2" v-if="item.status == 5">Доставлено</div>
								</div>
								<div class="detail f-ct">
									<div class="msg f-ct">
										<el-image class="img" @click.stop="showImgViewer([item.imageUrl])" v-if="item.imageUrl" :src="item.imageUrl"></el-image>
										<el-image class="img" v-else :src="require('@/static/img4.png')"></el-image>
										<div class="r f-ct">
											<div class="cBox f-ct">
												<div class="nubitm">
													<el-image :src="require('@/static/icon17.png')"></el-image>
													<p>Длина：{{item.length||'?'}}см</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon18.png')"></el-image>
													<p>Ширина：{{item.width||'?'}}см</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon19.png')"></el-image>
													<p>Высота：{{item.height||'?'}}см</p>
												</div>
											</div>
											<div class="cBox f-ct">
												<div class="nubitm">
													<el-image :src="require('@/static/icon20.png')"></el-image>
													<p>Объём：{{item.volume||'?'}}см³</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon21.png')"></el-image>
													<p>Вес：{{item.weight||'?'}}кг</p>
												</div>
												<!-- <div class="nubitm">
													<el-image :src="require('@/static/icon22.png')"></el-image>
													<p>Количество：{{item.miniPackageNum||'?'}}шт</p>
												</div> -->
												<div class="nubitm">
													<el-image :src="require('@/static/icon32.png')"></el-image>
													<p>Плотность：{{item.density||'?'}}KG/m³</p>
												</div>
											</div>
										</div>
									</div>
									<div class="bor"></div>
									<div class="caozuo">
										<p class="t1" @click="link('/bigBagMsg',{id:item.id})">Подробности</p>
										<!-- <p class="t2">Удалить заказ</p> -->
									</div>
								</div>
							</div>
						</div>
						<!-- Нет данных -->
						<div class="zw" v-if="!packageBigArr.length">
							<el-image :src="require('@/static/zw1.png')"></el-image>
							<p class="t1">Нет данных о крупных посылках</p>
						</div>
					</div>
					<div class="mtBox">
						<div class="tit f-bct">
							<div class="tl">
								<div class="bor"></div>
								<p>Тарифы</p>
							</div>
							<div class="tr" @click="link('/tableList')">
								<p>Подробнее</p>
								<el-image :src="require('@/static/icon16.png')"></el-image>
							</div>
						</div>
						<div class="tableImgList" @click="showImgViewer(imgListArr)">
							<el-image v-for="item in imgListArr" :src="item"></el-image>
						</div>
						<!-- Нет данных -->
						<!-- <div class="zw">
							<el-image :src="require('@/static/zw2.png')"></el-image>
							<p class="t1">Нет данных</p>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<!-- Всплывающие окна -->
		<div class="maskBg" v-if="hbSubmitN"></div>
		<div class="subTips" v-if="hbSubmitN">
			<div class="title f-bct">
				<p>Редактировать маркировку</p>
				<el-image @click="hbSubmitN=false" :src="require('@/static/icon26.png')"></el-image>
			</div>
			<div class="iptBox f-ct">
				<p class="lab">Название маркировки</p>
				<div class="ipt">
					<el-input type="text" v-model="memberCode" placeholder="Введите название"></el-input>
				</div>
			</div>
			<div class="iptBox f-ct">
				<p class="lab">По умолчанию</p>
				<div class="ipt f-ct">
					<div class="selItm" @click="isDefault = 1">
						<el-image v-if="isDefault==1" :src="require('@/static/icon28.png')"></el-image>
						<el-image v-else :src="require('@/static/icon27.png')"></el-image>
						<p>Да</p>
					</div>
					<div class="selItm" @click="isDefault = 0">
						<el-image v-if="isDefault==0" :src="require('@/static/icon28.png')"></el-image>
						<el-image v-else :src="require('@/static/icon27.png')"></el-image>
						<p>Нет</p>
					</div>
				</div>
			</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbSubmitN=false">Назад</div>
				<div class="b2" @click="memberCodeUpdate">Изменить</div>
			</div>
		</div>
		<!-- Удаление -->
		<div class="maskBg" v-if="hbDel"></div>
		<div class="subTips" style="width: 402px;" v-if="hbDel">
			<el-image class="cha" @click="hbDel=false" :src="require('@/static/icon26.png')"></el-image>
			<div class="txt">Удалить маркировку</div>
			<div class="t1">Вы уверены, что хотите удалить маркировку <span>{{mtItem.memberCode}}</span>？</div>
			<div class="btnBox f-ct" style="margin-top: 30px;">
				<div class="b1" @click="hbDel=false">Назад</div>
				<div class="b2" @click="memberCodeRemove">Подтвердить</div>
			</div>
		</div>
		<!-- Удаление -->
		<div class="maskBg" v-if="hbDel1"></div>
		<div class="subTips" style="width: 402px;" v-if="hbDel1">
			<el-image class="cha"  @click="hbDel1=false" :src="require('@/static/icon26.png')"></el-image>
			<div class="txt">Удалить заказ</div>
			<div class="t1">Вы уверены, что хотите удалить этот заказ？</div>
			<div class="btnBox f-ct" style="margin-top: 30px;">
				<div class="b1" @click="hbDel1=false">Назад</div>
				<div class="b2" @click="packageMiniDelete">Подтвердить</div>
			</div>
		</div>
		<!-- Просмотр изображений -->
		<el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
	</div>
</template>
<script>
	import { adList,
		packageMiniList,
		memberCodeList,
		authMemberIndex,
		memberCodeRemove,
		memberCodeUpdate,
		packageMiniDelete,
		quotationList,
		applyLookDetail
	} from "/src/api/api.js"
	import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
	export default {
		components: {
			'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
			'leftBox': () => import('@/components/leftBox.vue')
		},
		data(){
			return {
				imgViewerVisible:false,
				imgList:[],
				imgListArr:[],
				bannerIdx:0,
				hbSubmitN:false,
				hbDel:false,
				hbDel1:false,
				// Полученные данные
				uinfoAll:'',
				adListArr:[],
				packageMiniArr:[],
				packageBigArr:[],
				memberCodeArr:[],
				memberCode:'',
				isDefault:1,
				mtItem:'',
				delBigId:0,
			}
		},
		mounted() {
			this.authMemberIndex()
			this.quotationList()
		},
		methods:{
			gowlink(url){
				var tempwindow=window.open('_blank');
				tempwindow.location=url;
			},
			// 申请查看包裹
			async applyLookDetailF(id){
				const res = await applyLookDetail({id})
				if(res.code==200){
					this.Tips(res.msg,'success')
					this.quotationList()
				}else{this.Tips(res.msg)}
			},
			// Запрос списка прайсов
			async quotationList(){
				const res = await quotationList({})
				if(res.code==200){
					var imgList = []
					res.rows.forEach((item)=>{
						imgList.push(item.image)
					})
					this.imgListArr = imgList
				}else{this.Tips(res.msg)}
			},
			// Удаление малой посылки
			async packageMiniDelete(){
				const res = await packageMiniDelete({id:this.delBigId})
				if(res.code==200){
					this.Tips(res.msg,'success')
					this.hbDel1 = false
					this.authMemberIndex()
				}else{this.Tips(res.msg)}
			},
			// Удаление маркировки
			mtDel(item){
				this.hbDel = true
				this.mtItem = item
			},
			async memberCodeRemove(){
				const res = await memberCodeRemove({id:this.mtItem.id})
				if(res.code==200){
					this.Tips(res.msg,'success')
					this.hbDel = false
					this.authMemberIndex()
				}else{this.Tips(res.msg)}
			},
			// Редактирование маркировки
			mtChange(item){
				this.memberCode = item.memberCode
				this.isDefault = item.isDefault
				this.mtItem = item
				this.hbSubmitN = true
			},
			async memberCodeUpdate(){
				const res = await memberCodeUpdate({
					id:this.mtItem.id,
					memberCode:this.memberCode,
					isDefault:this.isDefault,
				})
				if(res.code==200){
					this.Tips(res.msg,'success')
					this.hbSubmitN = false
					this.authMemberIndex()
				}else{this.Tips(res.msg)}
			},
			// Получение статистики
			async authMemberIndex(){
				const res = await authMemberIndex({})
				if(res.code==200){
					this.uinfoAll = res.data
					this.packageMiniArr = res.data.packageMiniList
					this.packageBigArr = res.data.packageBigList
					this.memberCodeArr = res.data.memberCodeList
					this.adListArr = res.data.bannerList
				}else{this.Tips(res.msg)}
			},
			// Карусель
			bannerC(e){
				this.bannerIdx = e
			},
			bannerDian(index){
				this.$refs.carousel.setActiveItem(index)
			},
			// Просмотр изображений
			showImgViewer(arr){
				this.imgList = arr
				this.imgViewerVisible = true;
				const m = (e) => { e.preventDefault() };
			},
			closeImgViewer(){
				this.imgViewerVisible = false;
			},
		},
		computed:{
			...mapState('userMsg',['userInfo']),
		}
	}
</script>
<style lang="scss">
	body{
		// background: #f6f7fb;
	}
</style>
<style lang="scss" scoped>
	.pcon{
		padding: 0 74px;
		padding-bottom: 46px;
	}
	.banner{
		width: 100%;
		height: 413px;
		.el-image{
			width: 100%;
			height: 413px;
			border-radius: 18px;
		}
		.dian{
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			bottom: 16px;
			z-index: 2;
			div{
				margin: 0 3px;
				width: 8px;
				height: 8px;
				border-radius: 8px;
				background: #00000033;
				transition:0.3s;
			}
			.a{
				background: #fff;
				width: 14px;
				transition:0.3s;
			}
		}
	}
	.pageCon{
		margin-top: 32px;
		justify-content: space-between;
		.pageConL{
			width: 530px;
		}
		.pageConR{
			width: calc(100% - 562px);
			.userNub{
				.itm{
					width: 382px;
					height: 158px;
					border-radius: 12px;
					background: #fff;
					padding-right: 46px;
					padding-left: 36px;
					.el-image{
						width: 80px;
					}
					.txt{
						width: calc(100% - 90px);
						margin-right: 10px;
						.t1{
							font-size: 42px;
							font-weight: bold;
						}
						.t2{
							font-size: 20px;
							color: #666666;
						}
					}
				}
			}
			.listBox{
				margin-top: 32px;
				.tit{
					.tl{
						display: flex;
						align-items: center;
						.bor{width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;}
						p{
							font-size: 18px;
							padding-left: 10px;
						}
					}
					.tr{
						display: flex;
						align-items: center;
						cursor: pointer;
						.el-image{
							width: 20px;
						}
						p{
							font-size: 16px;
							color: #666666;
						}
					}
				}
				.zw{
					padding-top: 0;
					.el-image{
						margin-bottom: 0;
					}
				}
				.smallBox{
					width: 796px;
					height: 411px;
					background: #fff;
					border-radius: 12px;
					padding: 24px;
					.smallList{
						margin-top: 16px;
						height: 340px;
						overflow: scroll;
						.itm{
							border: 1px solid #EFF1F6;
							border-radius: 8rpx;
							margin-bottom: 16px;
							.sn{
								height: 56px;
								border-bottom: 1px solid #EFF1F6;
								background: #EFF1F6;
								padding: 0 24px;
								.t1{
									font-size: 16px;
									color: #999999;
									span{
										color: #333;
									}
								}
								.t3{
									.snTxt{
										font-size: 16px;
										color: #999999;
										span{
											color: #333;
										}
									}
									.bor{
										width: 1px;
										height: 16px;
										background: #D9D9D9;
										margin: 0 24px;
									}
									.man{
										font-size: 16px;
									}
								}
								.t2{
									// width: 72px;
									padding: 0 6px;
									height: 30px;
									background: #C7F3F5;
									font-size: 14px;
									color: #38ABB0;
									text-align: center;
									line-height: 30px;
									border-radius: 4px;
								}
							}
							.detail{
								padding: 16px 0;
								.msg{
									width: calc(100% - 105px);
									padding-left: 24px;
									.img{
										width: 66px;
										height: 66px;
										border-radius: 6px;
										margin-right: 16px;
									}
									.r{
										width: calc(100% - 82px);
										.cBox{
											margin-bottom: 10px;
											&:last-child{
												margin-bottom: 0;
											}
										}
										.nubitm{
											display: flex;
											align-items: center;
											width: 176px;
											.el-image{
												width: 20px;
												height: 20px;
												margin-right: 6px;
											}
											p{
												font-size: 16px;
											}
										}
									}
								}
								.bor{
									width: 1px;
									height: 50px;
									background: #D9D9D9;
								}
								.caozuo{
									width: 104px;
									p{
										text-align: center;font-size: 12px;
										cursor: pointer;
									}
									.t1{
										color: #38ABB0;
									}
									.t2{
										color: #FF4D5A;
										margin-top: 6px;
									}
								}
							}
						}
					}
				}
				.mtBox{
					width: 382px;
					height: 411px;
					background: #fff;
					border-radius: 12px;
					padding: 24px;
					.maitouList{
						margin-top: 16px;
						height: 330px;
						overflow: scroll;
						.mtItm{
							margin-bottom: 22px;
							.l{
								width: 100%;
								margin-bottom: 12px;
								// background: #999;
								.nub{
									height: 20px;
									background: #38ABB0;
									margin-right: 12px;
									color: #fff;
									border-radius: 20px;
									font-size: 13px;
									text-align: center;
									line-height: 19px;
									padding: 0 5px;
									padding-left: 6px;
								}
								.el-image{
									width: 45px;
								}
								p{
									font-size: 16px;
									padding-left: 6px;
								}
							}
							.r{
								display: flex;
								align-items: center;justify-content: center;
								width: 100%;
								.bor{
									width: 1px;
									height: 16px;
									margin: 0 10px;
									background: #D9D9D9;
								}
								.btnItm{
									display: flex;
									align-items: center;
									cursor: pointer;
									.el-image{
										width: 14px;
										margin-right: 4px;
									}
									p{
										font-size: 14px;
									}
									.t1{
										color: #38ABB0;
									}
									.t2{
										color: #FF4D5A;
									}
								}
							}
						}
					}
					.tableImgList{
						margin-top: 16px;
						height: 340px;
						overflow: scroll;
						.el-image{
							width: 100%;
							height: 154px;
							margin-bottom: 16px;
							border-radius: 12px;
						}
					}
				}
			}
		}
	}
	.maskBg{
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.4);
		z-index: 10;
	}
	.subTips{
		position: fixed;
		width: 764px;
		padding-bottom: 34px;
		background: #fff;
		border-radius: 8px;
		z-index: 11;
		top: 50%;
		left: 50%;
		transform: translateX(-50%)translateY(-50%);
		.title{
			height: 69px;
			padding: 0 30px;
			background: #FAFBFC;
			border-radius: 8px 8px 0 0;
			margin-bottom: 40px;
			.el-image{
				width: 14px;
			}
			p{
				font-size: 18px;
			}
		}
		.cha{
			position: absolute;
			right: 20px;
			top: 20px;
			width: 14px;
			height: 14px;
		}
		.icon{
			display: block;
			margin: auto;
			margin-top: 48px;
			width: 115px;
			height: 115px;
		}
		.txt{
			font-size: 18px;
			font-weight: 600;
			color: #2F3541;
			margin-top: 35px;
			text-align: center;
		}
		.t1{
			font-size: 18px;
			color: #7D7D89;
			text-align: center;
			margin-top: 25px;
			span{
				color: #38ABB0;
				padding: 0 4px;
			}
		}
		.t2{
			font-size: 18px;
			color: #FF5F5A;
			padding: 0 27px;
			text-align: center;
			margin-top: 12px;
			line-height: 28px;
			span{
				color: #2F3541;
			}
		}
		.t3{
			font-size: 14px;
			color: #999999;
			padding: 0 27px;
			text-align: center;
			margin-top: 12px;
			line-height: 28px;
			span{
				color: #2F3541;
			}
		}
		.iptBox{
			width: 403px;
			margin: auto;
			margin-bottom: 20px;
			&:last-child{
				margin-bottom: 0;
			}
			.lab{
				font-size: 16px;
				color: #9A9DA7;
				width: calc(100% - 307px);
			}
			.ipt{
				width: 307px;
				border: 1px solid #E8EDF4;
				border-radius: 8px;
				padding: 0 20px;
				height: 50px;
				display: flex;
				align-items: center;
				::v-deep .el-input__inner{
					border: none;
					padding: 0 0;
					font-size: 0.16rem;
					background: none;
				}
				.selItm{
					display: flex;
					align-items: center;
					margin-right: 80px;
					.el-image{
						width: 20px;
						margin-right: 8px;
					}
					p{
						font-size: 16px;
					}
				}
			}
		}
		.btnBox{
			margin-top: 42px;
			justify-content: center;
			div{
				width: 162px;
				height: 46px;
				border-radius: 6px;
				text-align: center;
				line-height: 46px;
				font-size: 16px;
				cursor: pointer;
			}
			.b1{
				background: #F6F6F6;
				color: #666;
			}
			.b2{
				background: #38ABB0;
				color: #fff;
				margin-left: 14px;
			}
		}
	}
</style>